// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Compose from "../Data.Functor.Compose/index.js";
import * as Data_HeytingAlgebra from "../Data.HeytingAlgebra/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var Final = function (x) {
    return x;
};
var functorFinal = Data_Functor_Compose.functorCompose(Specular_FRP_Base.functorDynamic)(Data_Validation_Semigroup.functorV);
var applyFinal = Data_Functor_Compose.applyCompose(Specular_FRP_Base.applyDynamic)(Data_Validation_Semigroup.applyV(Data_Map_Internal.semigroupMap(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))));
var applicativeFinal = Data_Functor_Compose.applicativeCompose(Specular_FRP_Base.applicativeDynamic)(Data_Validation_Semigroup.applicativeV(Data_Map_Internal.semigroupMap(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))));
var userVisibleErrors = function (errors) {
    return Data_Map_Internal.singleton(Data_Maybe.Nothing.value)(Data_Functor.mapFlipped(Data_Functor.functorArray)(errors)(function (message) {
        return {
            fieldName: Data_Maybe.Nothing.value,
            fieldLabel: Data_Maybe.Nothing.value,
            message: message,
            internal: false
        };
    }));
};
var userVisibleError = function (message) {
    return userVisibleErrors([ message ]);
};
var unFinalV = function (v) {
    return v;
};
var semigroupFinal = function (dictSemigroup) {
    return {
        append: Control_Apply.lift2(applyFinal)(Data_Semigroup.append(dictSemigroup))
    };
};
var monoidFinal = function (dictMonoid) {
    return {
        mempty: Control_Applicative.pure(applicativeFinal)(Data_Monoid.mempty(dictMonoid)),
        Semigroup0: function () {
            return semigroupFinal(dictMonoid.Semigroup0());
        }
    };
};
var makeFinalV = function ($18) {
    return Final(Data_Functor_Compose.Compose($18));
};
var internalError = function (message) {
    return Data_Map_Internal.singleton(Data_Maybe.Nothing.value)([ {
        fieldName: Data_Maybe.Nothing.value,
        fieldLabel: Data_Maybe.Nothing.value,
        message: message,
        internal: true
    } ]);
};
var unknownError = internalError("Unknown error");
var invalidFinal = Final(Data_Functor_Compose.Compose(Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic)(Data_Validation_Semigroup.invalid(unknownError))));
var makeFinal = (function () {
    var $19 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.maybe(Data_Validation_Semigroup.invalid(unknownError))(Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Data_Map_Internal.semigroupMap(Data_Maybe.ordMaybe(Data_Ord.ordArray(Data_Ord.ordString)))))));
    return function ($20) {
        return makeFinalV($19($20));
    };
})();
var liftDynamic = (function () {
    var $21 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.Just.create);
    return function ($22) {
        return makeFinal($21($22));
    };
})();
var liftMaybe = (function () {
    var $23 = Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
    return function ($24) {
        return makeFinal($23($24));
    };
})();
var heytingAlgebraFinal = function (dictHeytingAlgebra) {
    return {
        ff: Control_Applicative.pure(applicativeFinal)(Data_HeytingAlgebra.ff(dictHeytingAlgebra)),
        tt: Control_Applicative.pure(applicativeFinal)(Data_HeytingAlgebra.tt(dictHeytingAlgebra)),
        implies: Control_Apply.lift2(applyFinal)(Data_HeytingAlgebra.implies(dictHeytingAlgebra)),
        conj: Control_Apply.lift2(applyFinal)(Data_HeytingAlgebra.conj(dictHeytingAlgebra)),
        disj: Control_Apply.lift2(applyFinal)(Data_HeytingAlgebra.disj(dictHeytingAlgebra)),
        not: Data_Functor.map(functorFinal)(Data_HeytingAlgebra.not(dictHeytingAlgebra))
    };
};
var hasFieldFinal = function (dictHasField) {
    return {
        getField: function (label) {
            return Data_Functor.map(functorFinal)(Data_Record.getField(dictHasField)(label));
        }
    };
};
var getErrors = (function () {
    var $25 = Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Validation_Semigroup.validation((function () {
        var $27 = Data_Array.fromFoldable(Data_Map_Internal.foldableMap);
        return function ($28) {
            return Data_Array.concat($27($28));
        };
    })())(function (v) {
        return [  ];
    }));
    return function ($26) {
        return $25(unFinalV($26));
    };
})();
var fromValidV = Data_Validation_Semigroup.validation(Data_Function["const"](Data_Maybe.Nothing.value))(Data_Maybe.Just.create);
var unFinal = function (v) {
    return Data_Functor.map(Specular_FRP_Base.functorDynamic)(fromValidV)(v);
};
var bindFinal = function (v) {
    return function (k) {
        return Final(Control_Bind.bind(Specular_FRP_Base.bindDynamic)(v)(function (x) {
            return Data_Validation_Semigroup.validation((function () {
                var $29 = Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
                return function ($30) {
                    return $29(Data_Validation_Semigroup.invalid($30));
                };
            })())(function (x$prime) {
                var v1 = k(x$prime);
                return v1;
            })(x);
        }));
    };
};
var additiveFinal = function (dictAdditive) {
    return {
        zero: Control_Applicative.pure(applicativeFinal)(Data_Numeric.zero(dictAdditive)),
        add: Control_Apply.lift2(applyFinal)(Data_Numeric.add(dictAdditive)),
        sub: Control_Apply.lift2(applyFinal)(Data_Numeric.sub(dictAdditive))
    };
};
export {
    fromValidV,
    liftDynamic,
    Final,
    bindFinal,
    unknownError,
    internalError,
    userVisibleError,
    userVisibleErrors,
    makeFinal,
    makeFinalV,
    liftMaybe,
    unFinal,
    unFinalV,
    invalidFinal,
    getErrors,
    functorFinal,
    applyFinal,
    applicativeFinal,
    heytingAlgebraFinal,
    semigroupFinal,
    monoidFinal,
    additiveFinal,
    hasFieldFinal
};
//# sourceMappingURL=index.js.map
